import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const DescendingIcon = (props: SvgProps) => <Svg
  width='24'
  height='24'
  viewBox='0 0 24 24'
  fill='none'
  {...props}
>
  <Path d='M3 4.5H17.25M3 9H12.75M3 13.5H12.75M17.25 9V21M17.25 21L13.5 17.25M17.25 21L21 17.25'
    stroke='#0058AD'
    strokeWidth='1.5'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default DescendingIcon;
